var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "top",
      "width": "auto",
      "trigger": "click"
    },
    on: {
      "show": _vm.handleShow,
      "hide": _vm.removeOutsidePointerListener
    },
    scopedSlots: _vm._u([{
      key: "reference",
      fn: function () {
        return [_vm._t("default")];
      },
      proxy: true
    }], null, true)
  }, [_c('VEmojiPicker', {
    key: `${_vm.pickerLocale}-${_vm.pickerVersion}`,
    attrs: {
      "i18n": _vm.pickerTranslations
    },
    on: {
      "select": _vm.selectEmoji
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };